<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center" style="width: 50px">ID</th>
          <th class="text-center" style="width: 70px">ステータス</th>
          <th class="text-left">メモ</th>
          <th class="text-left">発注登録日</th>
          <th class="text-left">登録者</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in orderRegistrations" :key="item.id">
          <td class="text-center">
            {{ item.id }}
          </td>
          <td class="text-center">
            <v-chip
              v-if="item.status == 'queued'"
              class="ma-2"
              color="warning"
              small
              label
            >
              待機中
            </v-chip>
            <v-chip
              v-else-if="item.status == 'completed'"
              class="ma-2"
              color="success"
              small
              label
            >
              完了
            </v-chip>
            <v-chip
              v-else-if="item.status == 'failed'"
              class="ma-2"
              color="error"
              small
              label
            >
              失敗
            </v-chip>
          </td>
          <td>{{ item.memo }}</td>
          <td>{{ item.createdAt | moment }}</td>
          <td>{{ item.user.name }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import moment from 'moment'

export default {
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    }
  },
  props: {
    orderRegistrations: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
